import React, { Component } from 'react';
import { Title } from 'react-admin';
import PeopleIcon from '@material-ui/icons/People';
import { withStyles } from '@material-ui/core/styles';
import CardStats from '../../components/CardStats';
import api from '../../lib/api';
import DashboardMenu from './DashboardMenu';
import LoadingOverlay from 'react-loading-overlay';

const styles = {
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'between',
  },
  formItem: {
    width: '20%',
    flexGrow: 1,
    paddingRight: '10px',
  },
  formSubmit: {
    alignSelf: 'end',
    flexGrow: 1,
  },
  formSubmitBtn: {
    width: '100%',
    color: 'white',
    padding: '11px',
    borderRadius: '3px',
    backgroundColor: '#2196f3',
    border: '1px solid #2196f3',
    cursor: 'pointer',
  },
  formInput: {
    width: '95%',
    marginTop: '5px',
    padding: '10px',
  },
  main: {
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'center',
  },
  inlineGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'center',
  },
  item: {
    flexGrow: 1,
    width: '100%',
    // marginLeft: '1em',
    marginTop: 40,
  },
  item_1_3: {
    flexGrow: 1,
    width: '32%',
    marginLeft: '14em',
    marginTop: 40,
  },
};

class DashboardReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      loading: true,
      error: null,
      form: {
        month: null,
        year: null,
        logins_times: null,
      },
    };
  }

  componentDidMount() {
    const today = new Date();
    this.setState({
      form: {
        month: today.getMonth() + 1,
        year: today.getFullYear(),
        logins_times: 5,
      },
    });

    this.filterResults();
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value, // aggiorna il campo specifico
      },
    }));
  };

  handleSubmit = event => {
    event.preventDefault();
    this.filterResults();
  };

  filterResults = () => {
    const today = new Date();

    this.setState({ loading: true });
    api({
      url: `/dashboard/monthly_stats?month=${this.state.form.month || today.getMonth() + 1}&year=${this.state.form
        .year || today.getFullYear()}&logins_times=${this.state.form.logins_times || 5}`,
      method: 'GET',
    })
      .then(response => this.setState({ data: response.data, loading: false }))
      .catch(error => this.setState({ error, loading: false }))
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { classes } = this.props;
    const { data, loading, error, form } = this.state;

    if (error) return <p>Error: {error.message}</p>;

    if (loading)
      return (
        <LoadingOverlay
          styles={{
            overlay: base => ({
              ...base,
              background: '#2196f357',
              borderRadius: '10px',
            }),
          }}
          active={loading}
          spinner
          text="Caricamento..."
        >
          <div style={{ paddingTop: '100vh' }} />
        </LoadingOverlay>
      );

    // Usa i dati recuperati
    const nuove_registrazione = data.nuove_registrazione || [];
    const totale_abbonati = data.totale_abbonati || [];
    const nuovi_abbonati_reg_entro_2_mesi = data.nuovi_abbonati_reg_entro_2_mesi || [];
    const nuovi_abbonati_reg_prima_2_mesi = data.nuovi_abbonati_reg_prima_2_mesi || [];
    const vecchi_abbonati_con_rinnovo_nello_stesso_mese = data.vecchi_abbonati_con_rinnovo_nello_stesso_mese || [];
    const vecchi_abbonati_con_rinnovo_mesi_precedenti = data.vecchi_abbonati_con_rinnovo_mesi_precedenti || [];
    const nuove_registrazione_ultimi_2_mesi = data.nuove_registrazione_ultimi_2_mesi || [];
    const totale_abbonati_senza_rinnovo = data.totale_abbonati_senza_rinnovo || [];
    const nuovi_registrati_con_senza_abbonamento_o_last_login =
      data.nuovi_registrati_con_senza_abbonamento_o_last_login || [];
    const nuovi_registrati_con_logins_lte_5 = data.nuovi_registrati_con_logins_lte_5 || [];
    const nuovi_registrati_con_logins_gt_5 = data.nuovi_registrati_con_logins_gt_5 || [];

    return (
      <div>
        <Title title="Dashboard Report" />

        <DashboardMenu active="reports" />

        <form className={classes.form} onSubmit={this.handleSubmit}>
          <div className={classes.formItem}>
            <label htmlFor="year">Seleziona Anno</label>
            <div>
              <input
                className={classes.formInput}
                name="year"
                type="number"
                min="2015"
                max={new Date().getFullYear()}
                value={form.year}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className={classes.formItem}>
            <label htmlFor="month">Seleziona Mese</label>
            <div>
              <input
                className={classes.formInput}
                name="month"
                type="number"
                min="1"
                max="12"
                value={form.month}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className={classes.formItem}>
            <label htmlFor="month">Seleziona Numero di login</label>
            <div>
              <input
                className={classes.formInput}
                name="logins_times"
                type="number"
                min="1"
                value={form.logins_times}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className={classes.formSubmit}>
            <button type="submit" className={classes.formSubmitBtn}>
              Filtra
            </button>
          </div>
        </form>

        <div className={classes.main}>
          {/* New registration */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Nuovi registrati nel mese selezionato"
              value={nuove_registrazione.totale}
              list={nuove_registrazione.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                  </tr>
                  {nuove_registrazione.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* New registration last 2 months */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Nuovi registrati nel mese selezionato ed in quello precedente"
              value={nuove_registrazione_ultimi_2_mesi.totale}
              list={nuove_registrazione_ultimi_2_mesi.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                  </tr>
                  {nuove_registrazione_ultimi_2_mesi.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* Sub total */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Totale abbonati nel mese selezionato"
              value={totale_abbonati.totale}
              list={totale_abbonati.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                  </tr>
                  {totale_abbonati.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* New sub in last 2 months */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Nuovi abbonati con created at entro gli ultimi 2 mesi"
              value={nuovi_abbonati_reg_entro_2_mesi.totale}
              list={nuovi_abbonati_reg_entro_2_mesi.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '15%' }}>Nome</th>
                    <th style={{ width: '15%' }}>Inizio</th>
                    <th style={{ width: '15%' }}>Scadenza</th>
                    <th style={{ width: '15%' }}>Pagato il</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                  </tr>
                  {nuovi_abbonati_reg_entro_2_mesi.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '15%' }}>{item.full_name}</td>
                      <td style={{ width: '15%' }}>{item.sub_start_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_end_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_payed_at}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* New sub in more than last 2 months */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Nuovi abbonati con created at in data precedente agli utlimi 2 mesi"
              value={nuovi_abbonati_reg_prima_2_mesi.totale}
              list={nuovi_abbonati_reg_prima_2_mesi.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '15%' }}>Nome</th>
                    <th style={{ width: '15%' }}>Inizio</th>
                    <th style={{ width: '15%' }}>Scadenza</th>
                    <th style={{ width: '15%' }}>Pagato il</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                  </tr>
                  {nuovi_abbonati_reg_prima_2_mesi.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '15%' }}>{item.full_name}</td>
                      <td style={{ width: '15%' }}>{item.sub_start_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_end_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_payed_at}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* Old sub that has a renew ( expired in this month ) */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Vecchi abbonati che hanno effettuato il rinnovo con vecchio abbonamento scaduto nel mese selezionato"
              value={vecchi_abbonati_con_rinnovo_nello_stesso_mese.totale}
              list={vecchi_abbonati_con_rinnovo_nello_stesso_mese.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '15%' }}>Nome</th>
                    <th style={{ width: '15%' }}>Inizio</th>
                    <th style={{ width: '15%' }}>Scadenza</th>
                    <th style={{ width: '15%' }}>Pagato il</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                    <th style={{ width: '20%' }}>Scadenza vecchio abbonamento</th>
                  </tr>
                  {vecchi_abbonati_con_rinnovo_nello_stesso_mese.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '15%' }}>{item.full_name}</td>
                      <td style={{ width: '15%' }}>{item.sub_start_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_end_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_payed_at}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                      <td style={{ width: '20%' }}>{item.old_sub_end_at}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* Old sub that has a renew ( expired less than this month ) */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Vecchi abbonati che hanno effettuato il rinnovo con vecchio abbonamento scaduto nel mesi precedenti rispetto a quello selezionato"
              value={vecchi_abbonati_con_rinnovo_mesi_precedenti.totale}
              list={vecchi_abbonati_con_rinnovo_mesi_precedenti.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '15%' }}>Nome</th>
                    <th style={{ width: '15%' }}>Inizio</th>
                    <th style={{ width: '15%' }}>Scadenza</th>
                    <th style={{ width: '15%' }}>Pagato il</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                    <th style={{ width: '20%' }}>Scadenza vecchio abbonamento</th>
                  </tr>
                  {vecchi_abbonati_con_rinnovo_mesi_precedenti.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '15%' }}>{item.full_name}</td>
                      <td style={{ width: '15%' }}>{item.sub_start_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_end_at}</td>
                      <td style={{ width: '15%' }}>{item.sub_payed_at}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                      <td style={{ width: '20%' }}>{item.old_sub_end_at}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* Expired sub with no renew */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Vecchi abbonati che non hanno effettuato il rinnovo"
              value={totale_abbonati_senza_rinnovo.totale}
              list={totale_abbonati_senza_rinnovo.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '15%' }}>Nome</th>
                    <th style={{ width: '15%' }}>Telefono</th>
                    <th style={{ width: '10%' }}>Inizio</th>
                    <th style={{ width: '10%' }}>Scadenza</th>
                    <th style={{ width: '10%' }}>Pagato il</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                  </tr>
                  {totale_abbonati_senza_rinnovo.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '15%' }}>{item.full_name}</td>
                      <td style={{ width: '15%' }}>{item.phone_number || ''}</td>
                      <td style={{ width: '10%' }}>{item.sub_start_at}</td>
                      <td style={{ width: '10%' }}>{item.sub_end_at}</td>
                      <td style={{ width: '10%' }}>{item.sub_payed_at}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* New registered last_login null */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label="Nuovi registrati non attivi"
              value={nuovi_registrati_con_senza_abbonamento_o_last_login.totale}
              list={nuovi_registrati_con_senza_abbonamento_o_last_login.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '15%' }}>Nome</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                    <th style={{ width: '15%' }}>Tipologia di utente</th>
                  </tr>
                  {nuovi_registrati_con_senza_abbonamento_o_last_login.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '15%' }}>{item.full_name}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                      <td style={{ width: '15%' }}>{item.type}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* New registered logins <= {{form.logins_times}} */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label={`Nuovi registrati con numero di login <= ${form.logins_times}`}
              value={nuovi_registrati_con_logins_lte_5.totale}
              list={nuovi_registrati_con_logins_lte_5.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '20%' }}>Nome</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                    <th style={{ width: '15%' }}>Tipologia di utente</th>
                    <th style={{ width: '20%' }}>Last Login At</th>
                    <th style={{ width: '20%' }}>Numero di login</th>
                  </tr>
                  {nuovi_registrati_con_logins_lte_5.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '20%' }}>{item.full_name}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                      <td style={{ width: '20%' }}>{item.type}</td>
                      <td style={{ width: '20%' }}>{item.last_login_at}</td>
                      <td style={{ width: '20%' }}>{item.logins_count || 0}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
          {/* New registered logins > {{form.logins_times}} */}
          <div className={classes.item}>
            <CardStats
              Icon={PeopleIcon}
              iconBgColor="green"
              label={`Nuovi registrati con numero di login > ${form.logins_times}`}
              value={nuovi_registrati_con_logins_gt_5.totale}
              list={nuovi_registrati_con_logins_gt_5.utenti}
              tbody={
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>id</th>
                    <th style={{ width: '20%' }}>Nome</th>
                    <th style={{ width: '20%' }}>Creazione utente</th>
                    <th style={{ width: '15%' }}>Tipologia di utente</th>
                    <th style={{ width: '20%' }}>Last Login At</th>
                    <th style={{ width: '20%' }}>Numero di login</th>
                  </tr>
                  {nuovi_registrati_con_logins_gt_5.utenti.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: '20%' }}>{item.id}</td>
                      <td style={{ width: '20%' }}>{item.full_name}</td>
                      <td style={{ width: '20%' }}>{item.user_created_at}</td>
                      <td style={{ width: '20%' }}>{item.type}</td>
                      <td style={{ width: '20%' }}>{item.last_login_at}</td>
                      <td style={{ width: '20%' }}>{item.logins_count || 0}</td>
                    </tr>
                  ))}
                </tbody>
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(DashboardReports);



// WEBPACK FOOTER //
// ./src/resources/dashboard/DashboardReports.jsx